import React from 'react';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import Services from '../components/Services';
import Process from '../components/Process';
import WhyUs from '../components/WhyUs';
import Industries from '../components/Industries';
import Reviews from '../components/Reviews';
import HomeCTA from '../components/HomeCTA';

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Process />
      <WhyUs />
      <Industries />
      <Reviews />
      <HomeCTA />
    </>
  );
}
